import { Growthchart } from '../../../Data/ApexChart'
import React from 'react';
import { Card, CardBody, CardHeader } from 'reactstrap';
import Chart from 'react-apexcharts';
import i18n from '../../../i18n';

const GrowthOverview = () => {
    return (
        <Card>

                <div title={i18n.t('Dashboard_Card_GrowthOverview')} subtitle={i18n.t('Dashboard_Card_GrowthSubtitle')} />

            <CardBody className="p-0 growth-overview">
                <div id="chart-dashbord">
                    <Chart options={Growthchart.options} series={Growthchart.series} type="radialBar" height={380} />
                </div>
            </CardBody>
        </Card>
    );
};

export default GrowthOverview;
